import ScanDocument from './ScanDocument';

export const ScanDocumentForm = ScanDocument;
